const trackFormFilling = () => {
  const forms = document.querySelectorAll("form");
  if (!forms.length) return;

  forms.forEach((form) => {
    const formInputs = form.querySelectorAll("input");
    const formSelects = form.querySelectorAll("select");
    let isFilling = false;

    const onFieldEvent = () => {
      if (!isFilling) {
        ym(99122101,'reachGoal','FormStart');
        ym(89966386, 'reachGoal', 'FormStart');
        isFilling = !isFilling;
      }
    };

    formInputs.forEach(input => input.addEventListener("input", onFieldEvent));
    formSelects.forEach(select => select.addEventListener("change", onFieldEvent));
  })
};

export default trackFormFilling;
